module.exports = __webpack_public_path__ + "017b97b22b867678420ec94aa5ac69d6.fbx";